import { useQuery } from "@tanstack/react-query";

const useGetAllTrialsList = () => {
  const userId = localStorage.getItem("uI");
  const user_id = userId - 786;
  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: getAllTrialsList = [],
  } = useQuery({
    queryKey: ["GetAllTrialsList"],
    queryFn: async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/trial`);
      const data = await res.json();
      // console.log("studies list", data.data.studies);
      return data.data;
    },
  });

  return [getAllTrialsList, isLoading, isError, error, isSuccess, refetch];
};

export default useGetAllTrialsList;
